import apiClient from './api';

export const getColors = () => apiClient.get('/resource/colors');

export const getResources = () => apiClient.get('/resource');

export const upsertResource = (data) => apiClient.post('/resource', data);

export const deleteResource = (id) => apiClient.delete(`/resource/${id}`);